const messages = {
  en: {
    navigation: {
      membership: 'Membership',
      payment: 'Payment',
      profile: 'Profile'
    },
    headers: {
      welcome: 'Welcome, {name}',
    },
    titles: {
      access_code: '...if you have a code!',
      early_access: 'Sign up here, or.....',
      password: 'Password',
      membership: 'Membership',
      yourMembership: 'Your Membership',
      membershipRequest: 'Membership Request',
      pendingMembership: 'Requested Membership',
      billing: "Billing",
      your_details: "Your Details",
      security_details: "Security",
      membership_details: "Membership",
      current_membership_plan: "Current plan",
      new_membership_plan: "New plan",
      payment_details: "Payment",
      change_payment: "Change Payment",
      user_details: "Your Details",
      coupon_details: "Coupon Details",
      success: "Thank you",
      stop_auto_renew: "Stop Auto-renew",
      new_payment_details: "New details",
      extend_membership: "Extend Membership",
      upgrade_membership: "Upgrade Membership",
      new_membership: "New membership",
      action_required: "Action Required",
      new_terms: "UPDATED TERMS & CONDITIONS",
      member_tickets: "Tickets",
      create_your_account: "Create Your Account"
    },
    buttons: {
      earlyAccess: "Sign Up Here",
      login: "Log in",
      forgot_password: "Forgot password?",
      reset_password: "Reset password",
      logout: 'Logout',
      create_account: 'Create Account',
      signup: 'Sign Up',
      contact_us: 'Contact Us',
      become_a_member: 'Become a member',
      not_a_member: 'Don\'t have an account yet?',
      already_have_an_account: 'Already have an account?',
      continue: 'Continue',
      processing_payment: 'Processing Payment ...',
      loading: 'Loading ...',
      processing: 'Processing ...',
      complete_payment: 'Pay now',
      confirm_payment: 'Pay now',
      submit_application: 'Submit Application',
      edit: 'Edit',
      edit_password: 'Edit Password',
      cancel: 'Cancel',
      stop_auto_renew: 'Stop Auto-renew',
      change: 'Change',
      abort: 'Abort',
      back: 'Back',
      save: 'Save',
      close: 'Close',
      get_tickets: 'Get your tickets',
      upgrade: 'Upgrade',
      extend: 'Extend',
      accept: "Accept",
      remind_me_later: "Remind me later",
      to_my_fotografiska: "My Profile",
      action_required: "Complete action",
    },
    labels: {
      access_code: 'You need a code in order to be able to see current memberships',
      email: "Email",
      password: "Password",
      new_password: "New password",
      password2: 'Confirm password',
      first_name: "First Name",
      last_name: "Last Name",
      address: "Address",
      city: "City",
      postal_code: "Zip Code",
      choose: "Choose",
      choose_new_plan: "Select membership type",
      select_membership_type: "Select membership type",
      country: "Country",
      state: "State",
      phone: "Phone",
      dob: "Date of birth",
      industry: "Industry",
      company_name: "Company",
      intro: "What will you bring to the community?",
      instagram: "Instagram Handle",
      linkedin: "LinkedIn Handle",
      favorite_artists: "Five Favorite Artists (Dead or Alive)",
      website: "Website",
      education: "Education",
      expected_graduation_date: "Expected Date of Graduation",
      valid_until: "Valid until",
      cancel_date: "Expires on",
      active_since: "Active since",
      trial_since: "Trial since",
      next_payment_date: "Next payment date",
      referred_by: "Referred by",
      referred_details: "How did you hear about us?",
      referred_by_friend: "Friend's email",
      referred_by_link_or_code: "URL or code",
      referred_by_other: "Describe",
      select: "Please select",
      coupon: "Coupon",
      password_placeholder: "Must be at least 5 characters",
      repeat_password: "Repeat password",
      accept_new_terms: "",
      switch_to_membership: "Switch to {membership}",
      provide_information: "Please provide your personal information below.",
    },
    errors: {
      invalid_access_code: 'The code you have provided is not valid',
      required: 'This field is required',
      valid_email: 'Please enter a valid email',
      invalid_phone: 'Please enter a valid phone number',
      min_length: 'Must be at least {min} characters',
      password_not_matching: 'password confirmation does not match',
      generic: 'Something went wrong'
    },
    tables: {
      type: 'Type',
      date: 'Date',
      verification: 'Verification',
      price: 'Price',
      download: "Download"
    },
    membership: {
      priceInfo: 'Price',
      inviteOnly: 'by invite only',
      learnMore: 'Learn More',
      membership: 'Membership',
      days_free: 'no trial | 1 day free | {count} days free',
      free_until: 'free until',
      then: 'then',
      per_n_months: '/month | /month | /{count} months',
      per_n_years: '/year | /year | /{count} years',
      for_n_months: 'for 0 month | for 1 month | for {count} months',
      for_n_years: 'for 0 year | for 1 year | for {count} years',
      plans_not_available_for_upgrade: 'Plans not available for upgrade at this moment',
      sorry_no_plans_available: "Sorry, no plans available now",
    },
    coupon: {
      for_n_months: "for 0 month|for 1 month|for {count} months",
      each_month: "each month",
    },
    messages: {
      account_updated: 'Your account was updated',
      reset_password_request_sent: 'If you have a valid account, password recovery instructions have been sent to the registered email address',
      valid_access_code: 'Looking good!',
      signup_email_success: 'Successfully subscribed',
      successfully_subscribed_text: "You've been successfully subscribed",
      successfully_subscribed_text_berlin: "You are now a member of Fotografiska Berlin! As a member, you receive exclusive access to free, reduced price, " +
      "or advanced tickets for Fotografiska events. From literature talks, to live music, club nights, to creative workshops, your membership gives an " +
      "abundance of cultural experiences, and, very soon, sensory adventures from Verōnika and Bar Clara.\n\n" +
      "Please check your email for membership confirmation.\n\n" +
      "We look forward to seeing you soon!",
      successfully_requested_text: "We have received your request to become a \"{membership_type_name}\" member and will get in touch with you shortly",
      upgrade_successfully_requested_text: "We have received your upgrade request to become a \"{membership_type_name}\" member and will get in touch with you shortly",
      you_are_all_set: "Thank you! You're all set to enjoy the new benefits and pricing as part of your Fotografiska membership.",
      action_required: "Your membership is now ready to be activated. You only need to validate the transaction for it to go through. This for your own security. \n\nClick below to validate your payment.",
      stop_auto_renew_title: "Are You Sure You Want to Stop Auto-renew?",
      stop_auto_renew_markdown: "By opting out you will not be charged the Membership Renewal Fee when your current Membership expires. Memberships not set to auto-renewal are subject to annual price increases.\n\n"+
        "If this was a mistake, please close this window and continue to enjoy Fotografiska without interruption.\n\n"+
        "*To end your membership auto-renewal click the “Stop Auto-renew” button.*"
    },
    referral_option: {
      not_applicable: "Not applicable",
      friend: "By a friend",
      link_or_code: "Referral link/code",
      other: "Other",
    },
    education_option: {
      jhs_hs: "JHS/HS",
      undergraduate: "Undergraduate",
      graduate: "Graduate",
      life_long_learner: "Life-long Learner",
    }
  }
}

const numberFormats = {
  'en': {
    new_york_currency: {
      style: 'currency', currency: 'USD', maximumFractionDigits: 0, minimumFractionDigits: 0
    },
    stockholm_currency: {
      style: 'currency', currency: 'SEK', maximumFractionDigits: 0, minimumFractionDigits: 0
    },
    berlin_currency: {
      style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0
    }
  }
}

export {
  messages,
  numberFormats
}
